import withStyles from '@mui/styles/withStyles';
import Tooltip from '@mui/material/Tooltip';

const ThemedTooltip = withStyles((theme, color = 'primary') => ({
  tooltip: {
    backgroundColor: theme.palette[color].light,
    color: theme.palette[color].contrastText,
    boxShadow: theme.shadows[3],
    fontSize: 13,
    padding: 8,
  },
}))(Tooltip);

export default ThemedTooltip;
